import { render, staticRenderFns } from "./PeiHistory.vue?vue&type=template&id=4469e5fe&scoped=true"
import script from "./PeiHistory.vue?vue&type=script&lang=js"
export * from "./PeiHistory.vue?vue&type=script&lang=js"
import style0 from "./PeiHistory.vue?vue&type=style&index=0&id=4469e5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4469e5fe",
  null
  
)

export default component.exports